import templateUrl from './report-history.component.html';
import { JobStatus } from '../../core/enum/job-status';
import { ReportJobVM } from '../../core/services';
import { EventEmitter } from '../../common/components/event-emitter';


export const ReportHistoryComponent = {
    bindings: {
        jobs: "<",
        caption: "@",
        viewDetails: "&onViewDetails",
        cancel: "&onCancel"
    },
    templateUrl,
    controller: class ReportHistoryComponent {
        caption: string;
        jobs: ReportJobVM[];
        JobStatus = JobStatus;
        pageNumber: 1;
        pageSize: 10;
        viewDetails: EventEmitter<{ job: ReportJobVM }>;
        cancel: EventEmitter<{ job: ReportJobVM }>;
        constructor() {
            'ngInject';
        }

        $onInit() {
            this.caption = this.caption || "Compliance Report History";
        }

        onViewDetails(job) {
            this.viewDetails({
                $event: {
                    job: job
                }
            });
        }

        onCancel(job) {
            this.cancel({
                $event: {
                    job: job
                }
            });
        }
    }
}
